import {
  AdTargetPlace,
  GetBannerAdExchange,
  GetBannerAdExchange_getBannerAdExchange
} from '@/api/bff_types';
import useGetAdBanner from '@/hooks/advertisement/useGetAdBanner';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';
import useSendAdBannerExposureLog from '@/hooks/advertisement/useSendAdBannerExposureLog';
import { useHistory } from 'react-router';
import { AD_BANNER_CLICK } from '@/constants/advertisement';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { pharmacyState } from '@/recoil/pharmacy';
import { UseQueryResult } from 'react-query';

const AD_VIEWER_OS_PLATFORM = 'web';

interface AdBannerHandleViewModel {
  readonly bannerData: GetBannerAdExchange_getBannerAdExchange;
  readonly handleAdOutlinkClick: () => void;
}

const useAdBannerHandleViewModel = (
  targetPlace: AdTargetPlace
): AdBannerHandleViewModel => {
  const auth = useRecoilValue(authState);
  const pharmacy = useRecoilValue(pharmacyState);

  const { token } = auth;
  const isLoggedIn = !isEmpty(pharmacy) && !!token;

  const { data: queryData, refetch } = useGetAdBanner(targetPlace)!;
  const bannerData = queryData?.getBannerAdExchange;
  const { mutate: sendExposureLog } = useSendAdBannerExposureLog();

  const history = useHistory();

  const handleAdOutlinkClick = () => {
    if (!bannerData || !queryData) {
      return;
    }
    const outlinkUrlWithQueryString = `${AD_BANNER_CLICK()}/${
      bannerData.bannerAdId
    }?adViewerOsPlatform=web&outlink=${bannerData.clickAction.outlink}${
      token ? `&u=${btoa(token)}` : ''
    }&${Date.now().valueOf()}`;

    window.open(outlinkUrlWithQueryString);
  };

  const handleAdBannerExposureLogSend = (
    response: GetBannerAdExchange_getBannerAdExchange
  ): void => {
    sendExposureLog({
      adId: response.bannerAdId,
      exposedAt: new Date().valueOf(),
      adViewerOsPlatform: AD_VIEWER_OS_PLATFORM
    });
  };

  useEffect(() => {
    if (isLoggedIn && bannerData) {
      handleAdBannerExposureLogSend(bannerData);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      refetch<UseQueryResult<GetBannerAdExchange | undefined>>().then(
        response => {
          if (!response.data) {
            return;
          }
          if (response.data.getBannerAdExchange) {
            handleAdBannerExposureLogSend(response.data.getBannerAdExchange);
          }
        }
      );
    }
  }, [history.location.pathname]);

  return {
    bannerData: bannerData!,
    handleAdOutlinkClick
  };
};

export default useAdBannerHandleViewModel;
